<template>
  <div>
    <section class="mainsection">
      <div class="container" style="margin-top:20px;">
        <div class="row">
          <div class="col-md-3 d-sm-none d-md-block">
            <nav-bar-pelaporan active="pelaporan-pajak"></nav-bar-pelaporan>
          </div>
          <div class="col-sm-pull-12 col-md-9">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="row row-grid">
                  <card class="border-0" shadow body-classes="py-5">
                    <div class="d-block">
                      <ValidationObserver v-slot="{ handleSubmit }">
                        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
                          <div class="alert alert-default">
                            <strong>Informasi!</strong> :
                            <ul>
                              <li>
                                Silahkan isi item rekening pajak yang ingin di laporkan dengan cara klik tambah
                                pajak
                              </li>
                              <li>
                                Upload bukti bayar Anda
                              </li>
                              <li>
                                Khusus MBLB Anda dapat menggunakan bukti bayar yang sama jika item MBLB di bayarkan dengan kode bayar yang sama
                              </li>
                            </ul>
                          </div>
                          <div class="alert alert-danger" v-if="error_msg.length > 0">
                            <strong>Warning!</strong> Perbaiki hasil input Anda :
                            <ul>
                              <li v-for="text in error_msg" :key="text">{{ text }}</li>
                            </ul>
                          </div>
                          <div class="mb-5">
                            <!-- /.page-header -->
                            <fieldset class="border rounded-3 p-3">
                              <legend class="float-none w-auto px-3" style="font-size: medium;">PERIODE PAJAK
                              </legend>
                              <div class="row">
                                <div class="col-md-3 col-sm-12">
                                  <base-input label="Tahun Pajak" v-model="form.year" readonly></base-input>
                                </div>
                                <div class="col-md-3 col-sm-12">
                                  <base-input label="Masa Pajak" :value="list_month[form.month]" readonly />
                                </div>
                              </div>
                            </fieldset>
                            <br>
                            <fieldset class="border rounded-3 p-3">
                              <legend class="float-none w-auto px-3" style="font-size: medium;">I. IDENTITAS SUBJEK PAJAK
                              </legend>
                              <div class="row">
                                <div class="col-md-6 col-sm-12">
                                  <base-input label="NIK / NIB" v-model="form.wajib_pajak.nik" readonly></base-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-8 mb-2">
                                  <base-input label="Nama Wajib Pajak" v-model="form.wajib_pajak.nama" readonly />
                                </div>
                              </div>
                            </fieldset>
                            <br>
                            <fieldset class="border rounded-3 p-3">
                              <legend class="float-none w-auto px-3" style="font-size: medium;">II. PAJAK BARANG DAN JASA
                                TERTENTU</legend>
                              <div class="row float-right mb-2">
                                <div class="col-md-12 col-sm-12">
                                  <base-button type="primary" nativeType="button" icon="fa fa-plus"
                                    @click="addPajak()">Tambah
                                    PBJT</base-button>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Objek PBJT</th>
                                      <th scope="col">Jenis PBJT</th>
                                      <th scope="col">Omzet</th>
                                      <th scope="col">Tarif PBJT</th>
                                      <th scope="col">Nilai Pajak</th>
                                      <th scope="col"></th>
                                      <th scope="col"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(detailPBJT, index) in form.taxes_reporting_pbjt" :key="index">
                                      <th scope="row">{{ index + 1 }}</th>
                                      <td>{{ detailPBJT.registration.npwpd + ' - ' + detailPBJT.registration.business_name
                                      }}
                                      </td>
                                      <td>{{ detailPBJT.registration.business.name }}</td>
                                      <td>{{
                                        formatMoney(
                                          detailPBJT.omzet
                                        ) }}</td>
                                      <td>{{ detailPBJT.tax.fare }}%</td>
                                      <td>{{
                                        formatMoney(
                                          detailPBJT.total_tax
                                        ) }}</td>
                                      <td>
                                        <button type="button" color="success" @click="
                                          downloadFile(detailPBJT.file)
                                          " size="small">
                                          Download Bukti Pembayaran
                                        </button>
                                      </td>
                                      <td><button type="button" style="margin-left: 5px" color="danger" @click="
                                        deletePajak(index)
                                        " size="small">
                                          Hapus Data Pajak
                                        </button></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </fieldset>
                            <br>
                            <fieldset class="border rounded-3 p-3">
                              <legend class="float-none w-auto px-3" style="font-size: medium;">III. PAJAK MINERAL BUKAN
                                LOGAM
                                DAN BATUAN</legend>
                              <div class="row float-right mb-2">
                                <div class="col-md-12 col-sm-12">
                                  <base-button type="primary" nativeType="button" icon="fa fa-plus"
                                    @click="addMBLB()">Tambah
                                    Pajak MBLB</base-button>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Jenis MBLB</th>
                                      <th scope="col">Volume</th>
                                      <th scope="col">Nilai Pasar</th>
                                      <th scope="col">Tarif MBLB</th>
                                      <th scope="col">Nilai Pajak</th>
                                      <th scope="col"></th>
                                      <th scope="col"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(detailMBLB, index) in form.taxes_reporting_mblb" :key="index">
                                      <th scope="row">{{ index + 1 }}</th>
                                      <td>{{ detailMBLB.tax.name }}</td>
                                      <td>{{
                                        formatMoney(
                                          detailMBLB.volume
                                        ) }}</td>
                                      <td>{{
                                        formatMoney(
                                          detailMBLB.tax.rental_value
                                        ) }}</td>
                                      <td>{{ detailMBLB.tax.fare }}%</td>
                                      <td>{{
                                        formatMoney(
                                          detailMBLB.total_tax
                                        ) }}</td>
                                      <td>
                                        <button type="button" color="success" @click="
                                          downloadFile(detailMBLB.file)
                                          " size="small">
                                          Download Bukti Pembayaran
                                        </button>
                                      </td>
                                      <td><button type="button" style="margin-left: 5px" color="danger" @click="
                                        deletePajakMBLB(index)
                                        " size="small">
                                          Hapus Data Pajak
                                        </button></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </fieldset>

                            <br>
                            <fieldset class="border rounded-3 p-3">
                              <legend class="float-none w-auto px-3" style="font-size: medium;">IV. PAJAK SARANG BURUNG
                                WALET
                              </legend>
                              <div class="row float-right mb-2">
                                <div class="col-md-12 col-sm-12">
                                  <base-button type="primary" nativeType="button" icon="fa fa-plus"
                                    @click="addWalet()">Tambah
                                    Pajak Walet</base-button>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">#</th>
                                      <th scope="col">Objek PBJT</th>
                                      <th scope="col">Jenis PBJT</th>
                                      <th scope="col">Omzet</th>
                                      <th scope="col">Tarif PBJT</th>
                                      <th scope="col">Nilai Pajak</th>
                                      <th scope="col"></th>
                                      <th scope="col"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(detailWalet, index) in form.taxes_reporting_walet" :key="index">
                                      <th scope="row">{{ index + 1 }}</th>
                                      <td>{{ detailWalet.registration.npwpd + ' - ' +
                                        detailWalet.registration.business_name
                                      }}
                                      </td>
                                      <td>{{ detailWalet.registration.business.name }}</td>
                                      <td>{{
                                        formatMoney(
                                          detailWalet.omzet
                                        ) }}</td>
                                      <td>{{ detailWalet.tax.fare }}%</td>
                                      <td>{{
                                        formatMoney(
                                          detailWalet.total_tax
                                        ) }}</td>
                                      <td>
                                        <button type="button" color="success" @click="
                                          downloadFile(detailWalet.file)
                                          " size="small">
                                          Download Bukti Pembayaran
                                        </button>
                                      </td>
                                      <td><button type="button" style="margin-left: 5px" color="danger" @click="
                                        deletePajakWalet(index)
                                        " size="small">
                                          Hapus Data Pajak
                                        </button></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </fieldset>
                          </div>
                          <!-- / PAGE CONTENT ENDS -->
                          <div class="row float-right">
                            <div class="col-md-12 col-sm-12">
                              <template v-if="isBusy">
                                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                                <strong>Loading...</strong>
                              </template>
                              <base-button v-else type="success" nativeType="submit" icon="ni ni-send">{{ edit ? "Update"
                                :
                                "Simpan" }}</base-button>
                            </div>
                          </div>
                        </form>
                      </ValidationObserver>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <add-pajak ref="modal-add-pajak" :year="form.year" @addData="addDataPajak"></add-pajak>
    <add-pajak-mblb ref="modal-add-pajak-mblb" :year="form.year" @addData="addDataPajakMBLB"></add-pajak-mblb>
    <add-pajak-walet ref="modal-add-pajak-walet" :year="form.year" @addData="addDataPajakWalet"></add-pajak-walet>
  </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import qs from "qs";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Money } from "v-money";
import Datepicker from "vuejs-datepicker";
import { BTable } from "bootstrap-vue";
import AddPajak from "./modal/AddPajak"
import AddPajakMblb from "./modal/AddPajakMBLB"
import AddPajakWalet from "./modal/AddPajakWalet"
import { formatMoney } from "accounting-js";
import navBarPelaporan from "./navBarPelaporan.vue"
export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    Money,
    Datepicker,
    BTable,
    AddPajak,
    AddPajakMblb,
    AddPajakWalet,
    navBarPelaporan
  },
  data() {
    return {
      list_month: {
        1: 'Januari',
        2: 'Febuary',
        3: 'Maret',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'Juli',
        8: 'Agustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'Desember'
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      form: {
        year: '',
        month: '',
        wajib_pajak: {
          nik: null,
          nama: null,
        },
        taxes_reporting_pbjt: [],
        taxes_reporting_mblb: [],
        taxes_reporting_walet: []
      },
      isBusy: false,
      error_msg: [],
      edit: false,
    };
  },
  mounted() {
    this.form.year = this.$route.params.year
    this.form.month = this.$route.params.month
    this.form.wajib_pajak.nik = this.$store.state.auth.user.nik
    this.form.wajib_pajak.nama = this.$store.state.auth.user.name
    this.loadData();
  },
  methods: {
    formatMoney(val) {
      return formatMoney(val, {
        symbol: "Rp. ",
        precision: 0,
        thousand: ".",
        decimal: ",",
      });
    },
    addPajak() {
      this.$refs["modal-add-pajak"].showModal();
    },
    addDataPajak(data) {
      console.log(data)
      this.form.taxes_reporting_pbjt.push(JSON.parse(JSON.stringify(data)))
    },
    deletePajak(index) {
      this.form.taxes_reporting_pbjt.splice(index, 1)
    },
    addMBLB() {
      this.$refs["modal-add-pajak-mblb"].showModal();
    },
    addDataPajakMBLB(data) {
      this.form.taxes_reporting_mblb.push(JSON.parse(JSON.stringify(data)))
    },
    deletePajakMBLB(index) {
      this.form.taxes_reporting_mblb.splice(index, 1)
    },
    addWalet() {
      this.$refs["modal-add-pajak-walet"].showModal();
    },
    addDataPajakWalet(data) {
      this.form.taxes_reporting_walet.push(JSON.parse(JSON.stringify(data)))
    },
    deletePajakWalet(index) {
      this.form.taxes_reporting_walet.splice(index, 1)
    },
    downloadFile(name) {
      axios({
        url: "/api/v1/download_pdf?filename=" + name, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", name); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    async loadData() {
      const me = this;
      try {
        me.error_msg = [];
        this.isBusy = true;
        let { status, data } = await axios.get(
          "/api/v2/taxes-reporting/show?year=" + this.form.year + "&month=" + this.$route.params.month,
        )

        if (status >= 200 && status <= 202) {
          console.log(data)
          data.taxes_reporting_pbjt.forEach(element => {
            me.addDataPajak(element);
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    },
    async submit() {
      const me = this;
      try {
        me.error_msg = [];
        this.isBusy = true;
        let { status } = await axios.post(
          "/api/v2/taxes-reporting",
          qs.stringify({ taxes_reporting: me.form })
        )

        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "",
            text: "Pelaporan Pajak Berhasil, Terima kasih sudah melapor pajak Anda. Silahakan cek email Anda untuk mendapatkan SPTPD atau unduh di daftar Pelaporan Pajak.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            me.$router.push('/pelaporan-pajak')
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 29px;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card {
  height: 100%;
  width: 100%;
}

.vs-table--tr>th {
  font-size: 1rem !important;
}


.vs-table--tr>td {
  font-size: 1rem !important;
}</style>
